import { render, staticRenderFns } from "./purchaseCode.vue?vue&type=template&id=a342284e&"
import script from "./purchaseCode.vue?vue&type=script&lang=js&"
export * from "./purchaseCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a342284e')) {
      api.createRecord('a342284e', component.options)
    } else {
      api.reload('a342284e', component.options)
    }
    module.hot.accept("./purchaseCode.vue?vue&type=template&id=a342284e&", function () {
      api.rerender('a342284e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/purchaseCode.vue"
export default component.exports